import React from "react";
import { Breadcrumb } from "antd";
import { Link, useLocation } from "react-router-dom";
import "./Breadcrumbs.scss";
import { ReactComponent as RightArrow } from "../../assets/icons/Expand_right.svg";

const Breadcrumbs = ({ headerName }) => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((item) => item);
  
  // Filter out the last segment if it's a number
  const filteredPathnames = pathnames.filter((item, index) => {
    if (index === pathnames.length - 1) {
      return !/^\d+$/.test(item);
    }
    return true;
  });

  return (
    <Breadcrumb separator={<RightArrow />} className="breadcrumb-container">
      <Breadcrumb.Item>
        <Link className="headerName">{headerName}</Link>
      </Breadcrumb.Item>
      {filteredPathnames.map((value, index) => {
        if (index === 0) {
          return null;
        }
        const pathTo = `/${filteredPathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === filteredPathnames.length - 1;
        const displayName = value.replace(/-/g, " ");

        return (
          <Breadcrumb.Item
            key={pathTo}
            className={isLast ? "breadcrumb-item-active" : "breadcrumb-item"}
          >
            {isLast ? displayName : <Link to={pathTo}>{displayName}</Link>}
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
};

export default Breadcrumbs;
